'use client';
import React from 'react';
import { FilterType } from './QRHistoryClient';

const filterOptions: { key: FilterType; label: string }[] = [
  { key: 'all', label: 'All Types' },
  { key: 'url', label: 'URL' },
  { key: 'upi', label: 'UPI' },
  { key: 'whatsapp', label: 'WhatsApp' },
  { key: 'wifi', label: 'WiFi' },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Phone' },
  { key: 'maps', label: 'Maps' },
  { key: 'text', label: 'Text' },
];

interface HistoryFiltersProps {
  search: string;
  onSearchChange: (v: string) => void;
  filterType: FilterType;
  onFilterChange: (v: FilterType) => void;
  totalCount: number;
}

export default function HistoryFilters({ search, onSearchChange, filterType, onFilterChange, totalCount }: HistoryFiltersProps) {
  return (
    <div className="bg-card rounded-2xl border border-border shadow-card p-4 space-y-3">
      <div className="flex flex-col sm:flex-row gap-3">
        {/* Search */}
        <div className="relative flex-1">
          <svg className="absolute left-3.5 top-1/2 -translate-y-1/2 text-muted-foreground" width="15" height="15" viewBox="0 0 15 15" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
            <circle cx="6.5" cy="6.5" r="5" />
            <path d="M10.5 10.5L13.5 13.5" />
          </svg>
          <input
            type="text"
            className="input-field"
            style={{ paddingLeft: '40px', paddingRight: search ? '40px' : '16px' }}
            placeholder="Search by URL, content, or type..."
            value={search}
            onChange={e => onSearchChange(e.target.value)}
          />
          {search && (
            <button
              onClick={() => onSearchChange('')}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                <line x1="2" y1="2" x2="12" y2="12" />
                <line x1="12" y1="2" x2="2" y2="12" />
              </svg>
            </button>
          )}
        </div>
        <div className="flex items-center gap-2 text-muted-foreground bg-secondary rounded-xl px-3 py-2 border border-border">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
            <rect x="1" y="1" width="5.5" height="5.5" rx="1" />
            <rect x="7.5" y="1" width="5.5" height="5.5" rx="1" />
            <rect x="1" y="7.5" width="5.5" height="5.5" rx="1" />
            <rect x="7.5" y="7.5" width="5.5" height="5.5" rx="1" />
          </svg>
          <span style={{ fontSize: '13px', fontWeight: 600 }}>{totalCount} results</span>
        </div>
      </div>

      {/* Filter chips */}
      <div className="flex flex-wrap gap-2">
        {filterOptions.map(opt => (
          <button
            key={`filter-${opt.key}`}
            onClick={() => onFilterChange(opt.key)}
            className={`px-3 py-1.5 rounded-xl border font-semibold transition-all duration-150 ${
              filterType === opt.key
                ? 'gradient-primary text-white border-transparent shadow-blue'
                : 'border-border text-muted-foreground hover:border-primary/30 hover:text-foreground bg-card'
            }`}
            style={{ fontSize: '12px' }}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}